export default function setupLightbox() {
      const images = document.querySelectorAll('.kg-image-card .kg-image, .kg-gallery-image img ');
      const lightboxOverlay = document.createElement('div');
      lightboxOverlay.className = 'v-lightbox-overlay';
      document.body.appendChild(lightboxOverlay);

      const styles = `
      .kg-image-card .kg-image, .kg-gallery-image img {
        cursor: zoom-in;
      }
      .v-lightbox-overlay {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        opacity: 0;
        transition: opacity 0.3s ease, transform 0.3s ease;
        overflow-y: auto;
        overscroll-behavior: contain;
      }
      
      .v-lightbox-overlay.show {
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 1;
      }
      
      .v-lightbox-content {
        position: relative;
        max-width: 90%;
        max-height: 90%;
        animation: lightbox-fade-in 0.3s ease;
      }
      
      @keyframes lightbox-fade-in {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
      
      .v-lightbox-image {
        display: block;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
      }
      
      .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 24px;
        cursor: pointer;
      }
      
      @media (max-width: 768px) {
        .v-lightbox-overlay.show {
          align-items: flex-start;
        }
      
        .v-lightbox-content {
          width: 90%;
          max-height: 90vh;
          animation: lightbox-fade-in 0.3s ease;
        }
      }
      
      `;

      const styleElement = document.createElement('style');
      styleElement.textContent = styles;
      document.head.appendChild(styleElement);
  
      function openLightbox(imageUrl, imageAlt) {
        const lightboxImage = document.createElement('img');
        lightboxImage.className = 'v-lightbox-image';
        lightboxImage.src = imageUrl;
        lightboxImage.alt = imageAlt;
  
        const lightboxContent = document.createElement('div');
        lightboxContent.className = 'v-lightbox-content';
        lightboxContent.appendChild(lightboxImage);
  
        const closeButton = document.createElement('span');
        closeButton.className = 'close-button';
        closeButton.innerHTML = '&times;';
        closeButton.addEventListener('click', closeLightbox);
        lightboxContent.appendChild(closeButton);
  
        lightboxOverlay.innerHTML = '';
        lightboxOverlay.appendChild(lightboxContent);
        lightboxOverlay.classList.add('show');
        document.body.style.overflow = 'hidden';
      }
  
      function closeLightbox() {
        lightboxOverlay.classList.remove('show');
        document.body.style.overflow = '';
      }
  
      images.forEach(function(image) {
        image.addEventListener('click', function() {
          const imageUrl = image.getAttribute('src');
          const imageAlt = image.getAttribute('alt');
          openLightbox(imageUrl, imageAlt);
        });
      });
  
      lightboxOverlay.addEventListener('click', function(event) {
        if (event.target === lightboxOverlay) {
          closeLightbox();
        }
      });
  }
  